import {
  CategorizedSignal,
  ServerCategorizedSignal,
} from '../compoundConditions/compoundConditions.types';

export function toLocalSignal(signal: ServerCategorizedSignal): CategorizedSignal {
  return {
    signals: signal.signals,
    categories: signal.categoryId,
    subCategories: signal.subCategories?.map((subCategory) => toLocalSignal(subCategory)) || [],
  };
}
